import { inject } from "mobx-react";
import React from "react";
import { getMessage, MessageContext } from "react-message-context";
import { withRouter } from "react-router-dom";
import ErrorPage from "./pages/ErrorPage";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error) {
    this.props.RestStore.logError(error);
    this.props.history.push(getMessage(this.context, "url.error")());
  }

  render() {
    if (this.state.hasError) {
      return <ErrorPage />;
    }

    return this.props.children;
  }
}

ErrorBoundary.contextType = MessageContext;

export default withRouter(inject("RestStore")(ErrorBoundary));
